
import { Navigate, useLocation } from 'react-router-dom';
import { decodeToken } from '../utils/jwtUtils'

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  const location = useLocation();

  if (!token) {
    // 토큰이 없으면 로그인 페이지로 이동
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const decoded = decodeToken(token);
  const isExpired = decoded?.exp && decoded.exp * 1000 < Date.now(); // exp는 초 단위 → ms로 변환

  if (isExpired) {
    // 만료된 토큰이면 로그아웃 처리 후 로그인 페이지로
    alert('세션이 만료되었습니다. 다시 로그인해주세요.');
    localStorage.removeItem('token');
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children; // 정상 접근
}
